/**
 * Végleges képek és videó helyei.
 * Illeszd be a feltöltött fájl teljes URL-jét az idézőjelek közé — amíg üres, egy semleges helykitöltő látszik.
 */

/** Hero: 6–8 mp-es, hang nélküli, ismétlődő videó (pl. .mp4) és opcionális poszterkép. */
export const heroVideo = 'https://cdn.magicpatterns.com/uploads/g32qgqPxZHrSWQfai4MW5J/HERO_HU.mp4'
export const heroVideoPoster = ''

/** A kézikönyv 10 valódi oldala (teljes oldal, vágás nélkül, nagyítható). */
export const manualPages: string[] = [
  'https://cdn.magicpatterns.com/uploads/qD2fN6PrUQAvb18Lp6ifZM/01_pag2.jpg',
  'https://cdn.magicpatterns.com/uploads/cacCNoMBvjit6NsnkyuTo6/02_pag6.jpg',
  'https://cdn.magicpatterns.com/uploads/3T4tBadWJcJAHFjUbbk3Ez/03_pag31.jpg',
  'https://cdn.magicpatterns.com/uploads/hBSNKVVdWtS4vuAqAKHZEg/04_pag43.jpg',
  'https://cdn.magicpatterns.com/uploads/vUHPKA9dDeioKzEM1Z9F3z/05_pag4.jpg',
  'https://cdn.magicpatterns.com/uploads/hCc6X6dQDve2MdSqtLE8K7/06_pag27.jpg',
  'https://cdn.magicpatterns.com/uploads/bc2XTDkM87dTm7Bxuvt75y/07_pag19.jpg',
  'https://cdn.magicpatterns.com/uploads/sNjLUSNpBiRxaCqm9TmzBi/08_pag15.jpg',
  'https://cdn.magicpatterns.com/uploads/k8sMvYqJvXmtVCiQyxvHFh/09_pag24.jpg',
  'https://cdn.magicpatterns.com/uploads/rmCk6d9mBjS5tt4yExbTSd/10_pag30.jpg',
]

/** „Gyógyuló szív” (2. tevékenység): kiszínezés előtt és után. */
export const flipFront = 'https://cdn.magicpatterns.com/uploads/bpFw9rngfTJMTdQ8vfUY2y/Elotte-Gyogyulo-sziv.png'
export const flipBack = 'https://cdn.magicpatterns.com/uploads/oM6UCTho6i8v3XBvSxdLDQ/Utana-Gyogyulo-sziv.png'

/** Fő termék, 6 bónusz borító, 2. kiadás. */
export const mainProductImage = 'https://cdn.magicpatterns.com/uploads/5PnWScyKVTe7jmMsK5jHgC/2B150.png'
export const bonusCovers: string[] = [
  'https://cdn.magicpatterns.com/uploads/tRKxMS5VbRmk6F2RnaZ2pE/BONO_1_HUNGRIA.png',
  'https://cdn.magicpatterns.com/uploads/kmzfMnBYqF3TvisqdoZefp/BONO_2_HUNGRIA.png',
  'https://cdn.magicpatterns.com/uploads/eXe9MYU7Hc3ABmmCMsjwGo/Caja_de_cartas_botanicas_Felelemoldo.png',
  'https://cdn.magicpatterns.com/uploads/1AoLxbZ87tfkfUgrADQkjc/Kit_terapeutico_acuarelado_en_luz_calida.png',
  'https://cdn.magicpatterns.com/uploads/5rgGUNJDikzVKNV68QKnm7/BONO_5_HUNGRIA.png',
  'https://cdn.magicpatterns.com/uploads/7ojD1A8Yd8ypj7PMLk77VV/BONO_6_HUNGRIA.png',
]
export const secondEditionImage = 'https://cdn.magicpatterns.com/uploads/dYnMhHovmb7VCFvaayVN4c/Caja_de_Arte_Terapeutico_Azul.png'

/** A teljes csomag mockupja (7. blokk). */
export const bundleMockup = ''

/** Az ajánlati kártya mockupja (Bevezető ajánlat). */
export const offerMockup = 'https://cdn.magicpatterns.com/uploads/b1DVt4SKedBZRYyaMbkjur/Kit_de_arteterapia_para_la_calma_interior_(1).png'

/** Kinyomtatott, kiszínezett oldalak az asztalon (4–6 kép). */
export const printedPhotos: string[] = [
  'https://cdn.magicpatterns.com/uploads/n26BXq9qVgnwbjQYceTGWD/Momento_acogedor_de_coloreado_terapeutico.png',
  'https://cdn.magicpatterns.com/uploads/wQqgUbg6Bvj7EGaRVtpASF/Mariposas_y_transformacion_personal.png',
  'https://cdn.magicpatterns.com/uploads/5tmvc4D81FhfGRLfKN7PAd/Cuatro_actividades_de_bienestar_en_tonos_pastel.png',
  'https://cdn.magicpatterns.com/uploads/oW37R8kdzyxYDrN6Ymsr2r/Coloreando_una_mandala_al_reves.png',
]
